import { BaseSeratoFilter } from '@/pixi/filters/BaseSeratoFilter'
import { EffectState } from '@/pixi/filters/types'

interface ChromaShiftUniforms {
  redOffsetInit: [number, number]
  greenOffsetInit: [number, number]
  blueOffsetInit: [number, number]
  isAudioReactive: boolean
  audioIntensity: number
}

export class ChromaShiftFilter extends BaseSeratoFilter {
  get uniforms (): ChromaShiftUniforms {
    return super.uniforms as ChromaShiftUniforms
  }

  constructor (effectState: EffectState) {
    const shader = `
    uniform vec2 redOffsetInit;
    uniform vec2 greenOffsetInit;
    uniform vec2 blueOffsetInit;
    uniform float audioIntensity;

    varying vec2 vTextureCoord;
    uniform sampler2D uSampler;

    uniform bool isAudioReactive;

    void main(void)
    {
      float intensity = isAudioReactive ? audioIntensity : 1.0;

      vec2 rOffset = redOffsetInit * intensity;
      vec2 gOffset = greenOffsetInit * intensity;
      vec2 bOffset = blueOffsetInit * intensity;

      vec4 rValue = texture2D(uSampler, vTextureCoord - rOffset);
      vec4 gValue = texture2D(uSampler, vTextureCoord - gOffset);
      vec4 bValue = texture2D(uSampler, vTextureCoord - bOffset);
      float alpha = (rValue.a + gValue.a + bValue.a) / 3.0;

      gl_FragColor = vec4(rValue.r, gValue.g, bValue.b, alpha);
    }`

    const uniforms: ChromaShiftUniforms = {
      redOffsetInit: [0, 0],
      greenOffsetInit: [0, 0],
      blueOffsetInit: [0, 0],
      isAudioReactive: false,
      audioIntensity: 0
    }

    super(
      effectState,
      undefined,
      shader,
      uniforms
    )
  }

  updateUniforms (): void {
    const intensity : number = this.effectState.intensity / 2
    this.uniforms.audioIntensity = this.getAudioIntensityValue()
    this.uniforms.redOffsetInit = [-0.015 - intensity * 0.2, 0]
    this.uniforms.blueOffsetInit = [0.025 + intensity * 0.2, 0]
    this.uniforms.isAudioReactive = this.effectState.audioReactivityEnabled
  }
}
